module.exports = __webpack_public_path__ + "static/img/IMG_20150610_224652.5817c8f9.jpg";